import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

export const INTERFACE_LANGUAGE_OPTIONS = Object.freeze([
  { value: "en", label: "English" },
  { value: "sq", label: "Shqip" },
]);

const ALBANIAN = Object.freeze({
  "Overview": "Pasqyra",
  "Work": "Puna",
  "Invoices": "Faturat",
  "Clients": "Klientët",
  "Active in {{year}}": "Aktiv në {{year}}",
  "Hide previous clients": "Fshih klientët e mëparshëm",
  "Show previous clients": "Shfaq klientët e mëparshëm",
  "No invoice activity in {{year}}": "Pa aktivitet faturimi në {{year}}",
  "Last invoiced": "Fatura e fundit",
  "No invoice history": "Pa histori faturimi",
  "Services": "Shërbimet",
  "History": "Historiku",
  "Reports": "Raportet",
  "Settings": "Cilësimet",
  "Account": "Llogaria",
  "More": "Më shumë",
  "Search": "Kërko",
  "Notifications": "Njoftimet",
  "Tasks": "Detyrat",
  "Reminders": "Kujtesat",
  "Workspace": "Hapësira e punës",
  "Accounting tools": "Mjetet e kontabilitetit",
  "Company archive": "Arkivi i bizneseve",
  "Archive": "Arkivi",
  "Accounting records": "Të dhënat kontabël",
  "Browse every managed business from one evidence index, or narrow the archive to an issuer, year, and accounting folder.": "Shfleto dokumentet e të gjitha bizneseve të menaxhuara ose kufizo arkivin sipas biznesit, vitit dhe dosjes kontabël.",
  "Review intake": "Shqyrto dokumentet",
  "Search company archive": "Kërko në arkivin e bizneseve",
  "Search filenames, folders, periods, or document types": "Kërko emra skedarësh, dosje, periudha ose lloje dokumentesh",
  "Search hidden in public mode": "Kërkimi është i fshehur në modalitetin publik",
  "Filter archive by issuing business": "Filtro arkivin sipas biznesit lëshues",
  "Filter archive by year": "Filtro arkivin sipas vitit",
  "Filter archive by folder": "Filtro arkivin sipas dosjes",
  "All years": "Të gjitha vitet",
  "All folders": "Të gjitha dosjet",
  "Indexed files": "Skedarë të indeksuar",
  "Accounting folders": "Dosje kontabël",
  "folders": "dosje",
  "accounting folder": "dosje kontabël",
  "accounting folders": "dosje kontabël",
  "need review": "kërkojnë shqyrtim",
  "needs review singular": "kërkon shqyrtim",
  "Need review": "Kërkojnë shqyrtim",
  "Names hidden": "Emrat janë fshehur",
  "Archive folders": "Dosjet e arkivit",
  "All records": "Të gjitha të dhënat",
  "All company records": "Të gjitha dokumentet e bizneseve",
  "Company records": "Dokumentet e biznesit",
  "Month not assigned": "Muaji nuk është caktuar",
  "Filed": "Arkivuar",
  "Private company document": "Dokument privat i biznesit",
  "indexed file": "skedar i indeksuar",
  "indexed files": "skedarë të indeksuar",
  "result": "rezultat",
  "results": "rezultate",
  "Preview": "Parashiko",
  "Review": "Shqyrto",
  "View": "Shiko",
  "Indexed": "Indeksuar",
  "Accepted": "Pranuar",
  "Permanent files": "Dosjet e përhershme",
  "VAT": "TVSH",
  "Bank statements": "Gjendjet bankare",
  "Monthly reports": "Raportet mujore",
  "Annual reports": "Raportet vjetore",
  "Purchase invoices": "Faturat blerëse",
  "Sales invoices": "Faturat shitëse",
  "Fixed assets": "Asetet fikse",
  "Sponsorships": "Sponsorizimet",
  "Other": "Të tjera",
  "No records match these filters": "Nuk u gjet asnjë dokument me këta filtra",
  "Try another company, accounting folder, year, or search phrase.": "Provo një biznes, dosje kontabël, vit ose kërkim tjetër.",
  "Clear filters": "Pastro filtrat",
  "Loading company archive": "Duke ngarkuar arkivin e bizneseve",
  "Preparing the authorized folders and document index.": "Duke përgatitur dosjet e autorizuara dhe indeksin e dokumenteve.",
  "Company archive is unavailable": "Arkivi i bizneseve nuk është i disponueshëm",
  "Folder index shortened": "Indeksi i dosjeve është shkurtuar",
  "Choose an issuing business to load its complete folder tree. Record totals, filters, and search remain authoritative.": "Zgjidh një biznes faturues për të ngarkuar strukturën e plotë të dosjeve. Totalet, filtrat dhe kërkimi mbeten të sakta.",
  "This folder tree is unusually large. Record totals, filters, and search remain authoritative.": "Kjo strukturë dosjesh është jashtëzakonisht e madhe. Totalet, filtrat dhe kërkimi mbeten të sakta.",
  "Load more records": "Ngarko më shumë dokumente",
  "Load more folders": "Ngarko më shumë dosje",
  "folders loaded": "dosje të ngarkuara",
  "Loading more...": "Duke ngarkuar...",
  "loaded": "të ngarkuara",
  "matching": "që përputhen",
  "Document intake": "Pranimi i dokumenteve",
  "Documents": "Dokumentet",
  "Banking": "Bankat",
  "QuickBooks export": "Eksporti për QuickBooks",
  "QuickBooks": "QuickBooks",
  "Declarations": "Deklaratat",
  "Admin overview": "Pasqyra e administrimit",
  "Managed businesses": "Bizneset e menaxhuara",
  "Team & access": "Ekipi dhe qasja",
  "Admin history": "Historiku i administrimit",
  "Administration": "Administrimi",
  "Daily work": "Puna ditore",
  "New invoice": "Faturë e re",
  "Newest issued": "Më të rejat sipas lëshimit",
  "Oldest issued": "Më të vjetrat sipas lëshimit",
  "Highest invoice number": "Numri më i lartë i faturës",
  "Lowest invoice number": "Numri më i ulët i faturës",
  "Imported history": "Historiku i importuar",
  "Review payment assumptions": "Shqyrto supozimet e pagesave",
  "Historical invoices are provisionally counted as paid. Confirm them, or mark exceptions as still unpaid.": "Faturat historike llogariten përkohësisht si të paguara. Konfirmoji ose shëno përjashtimet që ende nuk janë paguar.",
  "Back to invoices": "Kthehu te faturat",
  "imported payments need confirmation": "pagesa të importuara kërkojnë konfirmim",
  "Historical invoices are treated as paid until you mark an exception.": "Faturat historike trajtohen si të paguara derisa të shënosh një përjashtim.",
  "imported payment states still need confirmation": "gjendje të pagesave të importuara ende kërkojnë konfirmim",
  "They are treated as paid until you identify an unpaid invoice.": "Ato trajtohen si të paguara derisa të identifikosh një faturë të papaguar.",
  "Assumed paid value": "Vlera e supozuar si e paguar",
  "All unconfirmed": "Të gjitha të pakonfirmuara",
  "Confirm visible as paid": "Konfirmo të dukshmet si të paguara",
  "issued": "lëshuar",
  "Not paid": "E papaguar",
  "Confirm paid": "Konfirmo pagesën",
  "Imported payments are reviewed": "Pagesat e importuara janë shqyrtuar",
  "There are no unresolved historical payment assumptions.": "Nuk ka supozime të pazgjidhura për pagesat historike.",
  "Return to invoices": "Kthehu te faturat",
  "No unconfirmed invoices in this period": "Nuk ka fatura të pakonfirmuara në këtë periudhë",
  "Open all unconfirmed payments to continue.": "Hap të gjitha pagesat e pakonfirmuara për të vazhduar.",
  "Create invoice": "Krijo faturë",
  "Good morning": "Mirëmëngjes",
  "Good afternoon": "Mirëdita",
  "Good evening": "Mirëmbrëma",
  "Public mode": "Modaliteti publik",
  "Issuing business": "Biznesi lëshues",
  "All issuing businesses": "Të gjitha bizneset lëshuese",
  "Account workspace": "Hapësira e llogarisë",
  "Stored on this device": "Ruajtur në këtë pajisje",
  "Local workspace": "Hapësira lokale",
  "Guest reviewer": "Shikues mysafir",
  "Open current version": "Hap versionin aktual",
  "Switch": "Ndërro",
  "Back to search": "Kthehu te kërkimi",
  "Upload documents": "Ngarko dokumente",
  "Processing...": "Duke përpunuar...",
  "Import statement": "Importo pasqyrën",
  "Export calculation": "Eksporto kalkulimin",
  "Export report": "Eksporto raportin",
  "Add client": "Shto klient",
  "New service": "Shërbim i ri",
  "View all": "Shiko të gjitha",
  "Latest activity": "Aktiviteti i fundit",
  "Recent invoices": "Faturat e fundit",
  "Most recent first": "Më të rejat së pari",
  "No clients yet": "Ende nuk ka klientë",
  "Client profile": "Profili i klientit",
  "Outstanding": "Të papaguara",
  "Lifetime billed": "Gjithsej e faturuar",
  "Defaults": "Vlerat bazë",
  "Billing defaults": "Vlerat bazë të faturimit",
  "Client invoices": "Faturat e klientit",
  "Manage defaults": "Menaxho vlerat bazë",
  "Invoice this client": "Faturo këtë klient",
  "WhatsApp reminder": "Kujtesë në WhatsApp",
  "Export statement": "Eksporto pasqyrën",
  "Service": "Shërbimi",
  "Default rate": "Çmimi bazë",
  "Used": "Përdorur",
  "Change history": "Historiku i ndryshimeve",
  "All": "Të gjitha",
  "Organization": "Organizata",
  "Data": "Të dhënat",
  "Change": "Ndryshimi",
  "Performed by": "Kryer nga",
  "When": "Kur",
  "No changes in this category": "Nuk ka ndryshime në këtë kategori",
  "Future updates will be recorded automatically.": "Ndryshimet e ardhshme do të regjistrohen automatikisht.",
  "Task": "Detyrë",
  "Reminder": "Kujtesë",
  "Personal account": "Llogaria personale",
  "Accounting workflow": "Procesi i kontabilitetit",
  "Accounting workspace": "Hapësira e kontabilitetit",
  "Accounting export": "Eksporti i kontabilitetit",
  "Relationships": "Marrëdhëniet",
  "Reusable work": "Punë e ripërdorshme",
  "Performance": "Performanca",
  "Accountability": "Përgjegjshmëria",
  "Account identity": "Identiteti i llogarise",
  "Formatting": "Formatimi",
  "Continuity": "Vazhdimësia",
  "Invoice from": "Fatura nga",
  "Language and locale": "Gjuha dhe rajoni",
  "Document language and locale": "Gjuha dhe rajoni i dokumenteve",
  "Dashboard and document language, dates, and number formatting": "Gjuha e aplikacionit dhe e dokumenteve, datat dhe formati i numrave",
  "Account identity, communication, and logo": "Identiteti, komunikimi dhe logoja e organizatës",
  "Legal entities that can issue invoices": "Subjektet ligjore që mund të lëshojnë fatura",
  "Currency, due dates, numbering, and standard notes": "Valuta, afatet, numërimi dhe shënimet standarde",
  "Local storage, portable exports, and recovery": "Ruajtja lokale, eksportet portative dhe rikthimi",
  "Organization profile": "Profili i organizatës",
  "Issuing businesses": "Bizneset lëshuese",
  "Invoice defaults": "Vlerat bazë të faturave",
  "Data and backups": "Të dhënat dhe kopjet rezervuese",
  "Organization name": "Emri i organizatës",
  "Billing email": "Emaili i faturimit",
  "Account type": "Lloji i llogarise",
  "Default currency": "Valuta bazë",
  "Business organization": "Organizatë biznesi",
  "Change organization logo": "Ndrysho logon e organizatës",
  "Add issuing business": "Shto biznes lëshues",
  "Next invoice": "Fatura e ardhshme",
  "Next invoice number": "Numri i faturës së ardhshme",
  "When should payment be due?": "Kur duhet të paguhet fatura?",
  "Include Excel workbook": "Përfshi dokumentin Excel",
  "Export JSON": "Eksporto JSON",
  "Export ZIP": "Eksporto ZIP",
  "Import backup": "Importo kopjen rezervuese",
  "Complete portable data with embedded images": "Të dhënat e plota portative me imazhet e përfshira",
  "Manifest, records, and separate image files": "Manifesti, regjistrimet dhe skedarët e veçantë të imazheve",
  "Restore a validated JSON or ZIP archive": "Rikthe një arkiv të verifikuar JSON ose ZIP",
  "Weekly backup reminder": "Kujtesë javore për kopje rezervuese",
  "Show a reminder when no recent portable export is available.": "Shfaq një kujtesë kur nuk ka eksport portativ të fundit.",
  "Interface language": "Gjuha e aplikacionit",
  "Document language": "Gjuha e dokumentit",
  "Regional format": "Formati rajonal",
  "Date style": "Formati i datës",
  "Number style": "Formati i numrave",
  "Document preview": "Pamja e dokumentit",
  "Dashboard preview": "Pamja e aplikacionit",
  "Save changes": "Ruaj ndryshimet",
  "Save monthly close": "Ruaj mbylljen mujore",
  "Request missing": "Kërko dokumentet që mungojnë",
  "Monthly close": "Mbyllja mujore",
  "Business document readiness": "Gatishmëria mujore e dokumenteve",
  "Period": "Periudha",
  "Request by": "Kërko deri më",
  "Business": "Biznesi",
  "Confirm complete": "Konfirmo përfundimin",
  "Mark complete": "Shëno si të përfunduar",
  "Reopen": "Rihap",
  "No declarations required": "Nuk kërkohen deklarata",
  "Monthly close complete": "Mbyllja mujore përfundoi",
  "Manual upload": "Ngarkim manual",
  "Available now": "Në dispozicion",
  "ZIP batch": "Grup ZIP",
  "Folder, email, API": "Dosje, email, API",
  "Backend connection required": "Kërkohet lidhja me backend",
  "Needs review": "Kërkon shqyrtim",
  "Ready or accepted": "Gati ose pranuar",
  "Exceptions": "Përjashtimet",
  "Review queue": "Radha e shqyrtimit",
  "No documents waiting": "Nuk ka dokumente në pritje",
  "Choose an issuing business above, then upload files or a ZIP batch.": "Zgjidh biznesin lëshues më lart, pastaj ngarko skedarë ose një grup ZIP.",
  "Upload files or a ZIP batch to begin reviewing documents.": "Ngarko skedarë ose një grup ZIP për të filluar shqyrtimin.",
  "Document type": "Lloji i dokumentit",
  "Accounting period": "Periudha kontabël",
  "Source": "Burimi",
  "File evidence": "Dëshmia e skedarit",
  "Select a document": "Zgjidh një dokument",
  "Its source evidence and extracted fields will appear here.": "Burimi dhe fushat e nxjerra do të shfaqen këtu.",
  "Complete review": "Përfundo shqyrtimin",
  "Accept extraction": "Prano nxjerrjen",
  "Document-only settings": "Cilësimet e dokumenteve",
  "Profile information": "Të dhënat e profilit",
  "Full name": "Emri i plotë",
  "Role": "Roli",
  "Email": "Emaili",
  "Time zone": "Zona kohore",
  "Your navigation": "Navigimi yt",
  "For screen sharing and public demos": "Për ndarje të ekranit dhe prezantime publike",
  "Exit local workspace": "Dil nga hapësira lokale",
  "Sign out": "Dil nga llogaria",
  "Scope daily workspace by issuing business": "Filtro hapësirën ditore sipas biznesit lëshues",
  "Collected in": "Arkëtuar në",
  "Collected in {{month}}": "Arkëtuar në {{month}}",
  "Total billed": "Gjithsej të faturuara",
  "Across {{count}} invoice": "Në {{count}} faturë",
  "Across {{count}} invoices": "Në {{count}} fatura",
  "{{month}} collection": "Arkëtimet në {{month}}",
  "Paid": "Paguar",
  "Sent": "Dërguar",
  "Draft": "Draft",
  "Overdue": "E vonuar",
  "Partially paid": "Pjesërisht e paguar",
  "Archived": "Arkivuar",
  "Invoice": "Fatura",
  "Client": "Klienti",
  "Issued": "Lëshuar",
  "Due": "Afati",
  "Status": "Statusi",
  "Amount": "Shuma",
  "Actions": "Veprimet",
  "Invoice actions": "Veprimet e faturës",
  "Edit draft": "Ndrysho draftin",
  "Open invoice": "Hap faturën",
  "View details and activity": "Shiko detajet dhe aktivitetin",
  "Reuse as draft": "Ripërdor si draft",
  "Download PDF": "Shkarko PDF",
  "Download Excel": "Shkarko Excel",
  "Prepare email": "Përgatit emailin",
  "Archive invoice": "Arkivo faturën",
  "Restore invoice": "Rikthe faturën",
  "Cash in motion": "Lëvizja e parave",
  "Collection": "Arkëtimet",
  "Last 8 months": "8 muajt e fundit",
  "No history yet": "Ende nuk ka histori",
  "Collected": "Arkëtuar",
  "Expected by month end": "Pritet deri në fund të muajit",
  "Needs attention": "Kërkon vëmendje",
  "Next moves": "Hapat e ardhshëm",
  "On-time rate": "Pagesat në kohë",
  "No settled invoices yet": "Ende nuk ka fatura të paguara",
  "No dated settlements yet": "Ende pa pagesa me datë të konfirmuar",
  "Based on settled invoices": "Bazuar në faturat e paguara",
  "Clear for now": "Gjithçka në rregull",
  "Changes are saved to {{organization}}.": "Ndryshimet ruhen në {{organization}}.",
  "Issuer details and logos are saved from each business editor.": "Të dhënat dhe logot ruhen nga profili i secilit biznes lëshues.",
  "Mobile view": "Pamja mobile",
  "Minimal": "Minimal",
  "Advanced": "Avancuar",
  "Return to the secure start screen": "Kthehu në ekranin fillestar të sigurt",
  "Keep editable and unsent": "Mbaje të ndryshueshme dhe të padërguar",
  "Awaiting client payment": "Në pritje të pagesës së klientit",
  "A payment has been allocated": "Një pagesë është alokuar",
  "Payment is past its due date": "Pagesa e ka kaluar afatin",
  "Payment has been recorded": "Pagesa është regjistruar",
});

const TABLES = Object.freeze({ en: Object.freeze({}), sq: ALBANIAN });

export const normalizeInterfaceLanguage = (value) => value === "sq" ? "sq" : "en";

const interpolate = (value, variables = {}) => Object.entries(variables).reduce(
  (result, [key, replacement]) => result.replaceAll(`{{${key}}}`, String(replacement)),
  value,
);

export const createUiTranslator = (language = "en", supplementalTable = {}) => {
  const normalized = normalizeInterfaceLanguage(language);
  const baseTable = TABLES[normalized] || TABLES.en;
  const table = normalized === "sq" ? { ...baseTable, ...supplementalTable } : baseTable;
  return (value, variables) => interpolate(table[value] || value, variables);
};

const UiLanguageContext = createContext({ language: "en", t: createUiTranslator("en") });

export const UiLanguageProvider = ({ language = "en", children }) => {
  const normalized = normalizeInterfaceLanguage(language);
  const [supplementalTable, setSupplementalTable] = useState(null);
  useEffect(() => {
    let active = true;
    if (normalized !== "sq") {
      setSupplementalTable(null);
      return () => { active = false; };
    }
    import("./uiLanguageSq").then(({ default: table }) => {
      if (active) setSupplementalTable(table);
    }).catch(() => {
      if (active) setSupplementalTable(null);
    });
    return () => { active = false; };
  }, [normalized]);
  const value = useMemo(
    () => ({ language: normalized, t: createUiTranslator(normalized, supplementalTable || {}) }),
    [normalized, supplementalTable],
  );
  useEffect(() => {
    document.documentElement.lang = normalized;
  }, [normalized]);
  return <UiLanguageContext.Provider value={value}>{children}</UiLanguageContext.Provider>;
};

export const useUiLanguage = () => useContext(UiLanguageContext);
